// @flow

import ApiError from '../../entities/ApiError';
import I18n from '../../i18n/I18n';

import ApiErrorUtils from '../ApiErrorUtils';

export default class OrderApiErrors {

  static post(apiError: ApiError): string {
    // General errors:
    // 101 - missing right to post order on behalf of someone else
    // 102 - Missing user address
    // 103 - User address not found
    // 104 - User address missing geoPt
    // 106 - user needs to verify his phone to use credit
    // 107 - payment card was not registered for currency
    // 109 - payment card not found
    // 110 - restaurant not found or restaurant legal not found
    // 112 - not enough credit
    // 114 - credit bigger than amount
    // 115 - amount + tips too low (<0.50)
    // 116 - amount + tips too high (>200.0)
    // 117 - cannot use credit when currency != EUR
    // 118 - unsupported POS
    // 118 - Restaurant menu not found
    // 118 - POS method not supported
    // 119 - Payment failed too many times in the last 5 minutes
    // 121 - Can't get Bank User with id
    // 124 - PayMyTable bank account doesn't exist
    // 124 - PayMyTable credit payment failed
    // 141 - POS rejected order
    // 142 - One or more items ordered does not match the restaurant menu
    //
    // Payment errors:
    // 125 - Payment failed (generic error)
    // 126 - Transaction refused by the bank (Do not honor)
    // 127 - Transaction refused by the bank (Amount limit)
    // 128 - Transaction refused by the terminal
    // 129 - Transaction refused by the bank (card limit reached)
    // 130 - The card has expired
    // 131 - The card is inactive
    // 132 - The card is not active
    // 133 - Maximum number of attempts reached
    // 134 - Maximum amount exceeded
    // 135 - Debit limit exceeded
    // 136 - Amount limit
    // 137 - Transaction refused
    // 138 - Payment failed
    //
    // POS errors:
    // 401 - POS generic error
    // 402 - POS error: table does not exist
    // 405 - POS error: product(s) out of stock
    // 406 - POS error: the till cannot be reached
    // 407 - POS error: the restaurant is closed
    // 408 - POS error: user account not found
    // 409 - POS error: user account problem

    const errors = {
      // General errors:
      '101': I18n.tr('api.error.order.post.101'),
      '102': I18n.tr('api.error.order.post.102'),
      '103': I18n.tr('api.error.order.post.103'),
      '104': I18n.tr('api.error.order.post.104'),
      '106': I18n.tr('api.error.order.post.106'),
      '107': I18n.tr('api.error.order.post.107'),
      '109': I18n.tr('api.error.order.post.109'),
      '110': I18n.tr('api.error.order.post.110'),
      '112': I18n.tr('api.error.order.post.112'),
      '114': I18n.tr('api.error.order.post.114'),
      '115': I18n.tr('api.error.order.post.115'),
      '117': I18n.tr('api.error.order.post.117'),
      '118': I18n.tr('api.error.order.post.118'),
      '119': I18n.tr('api.error.order.post.119'),
      '121': I18n.tr('api.error.order.post.121'),
      '124': I18n.tr('api.error.order.post.124'),
      '141': I18n.tr('api.error.order.post.141'),
      '142': I18n.tr('api.error.order.post.142'),

      // Payment errors:
      '125': I18n.tr('api.error.order.post.125'),
      '126': I18n.tr('api.error.order.post.126'),
      '127': I18n.tr('api.error.order.post.127'),
      '128': I18n.tr('api.error.order.post.128'),
      '129': I18n.tr('api.error.order.post.129'),
      '130': I18n.tr('api.error.order.post.130'),
      '131': I18n.tr('api.error.order.post.131'),
      '132': I18n.tr('api.error.order.post.132'),
      '133': I18n.tr('api.error.order.post.133'),
      '134': I18n.tr('api.error.order.post.134'),
      '135': I18n.tr('api.error.order.post.135'),
      '136': I18n.tr('api.error.order.post.136'),
      '137': I18n.tr('api.error.order.post.137'),

      // POS errors:
      '401': I18n.tr('api.error.order.post.401'),
      '402': I18n.tr('api.error.order.post.402'),
      '405': I18n.tr('api.error.order.post.405'),
      '406': I18n.tr('api.error.order.post.406'),
      '407': I18n.tr('api.error.order.post.407'),
      '408': I18n.tr('api.error.order.post.408'),
      '409': I18n.tr('api.error.order.post.409'),
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'OrderApiErrors:post');
  };

  static put(apiError: ApiError): string {
    const errors = {
      '100': I18n.tr('api.error.order.put.100'), //Order not found
      '105': I18n.tr('api.error.order.put.105'), //Cannot change status of a canceled order
      '110': I18n.tr('api.error.order.put.110'), //No restaurant found
      '101': I18n.tr('api.error.order.put.101'), //Not your restaurant's order
      '103': I18n.tr('api.error.order.put.103'), //Payment not found for order
      '104': I18n.tr('api.error.order.put.104'), //User not found for order's payment
      '107': I18n.tr('api.error.order.put.107'), //Order payment cannot be refunded because money has been transferred to the restaurant already
      '106': I18n.tr('api.error.order.put.106'), //User account not found for order's userAccountPayment
    }

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'OrderApiErrors:put');
  };

  static delete(apiError: ApiError): string {
    const errors = {
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'OrderApiErrors:delete');
  };
}
